import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getProductsApi, getCategoriesApi } from '../../api/productApi';

export const fetchProducts   = createAsyncThunk('product/fetchAll', async (params, { rejectWithValue }) => {
  try { return (await getProductsApi(params)).data; } catch (e) { return rejectWithValue(e.response?.data?.message); }
});
export const fetchCategories = createAsyncThunk('product/fetchCats', async (_, { rejectWithValue }) => {
  try { return (await getCategoriesApi()).data; } catch (e) { return rejectWithValue(e.response?.data?.message); }
});

const productSlice = createSlice({
  name: 'product',
  initialState: {
    products:   [],
    categories: [],
    total:      0,
    totalPages: 1,
    loading:    false,
    error:      null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending,    (state) => { state.loading = true; state.error = null; })
      .addCase(fetchProducts.fulfilled,  (state, { payload }) => {
        state.loading    = false;
        state.products   = payload.products;
        state.total      = payload.total;
        state.totalPages = payload.totalPages;
      })
      .addCase(fetchProducts.rejected,   (state, { payload }) => { state.loading = false; state.error = payload; })
      .addCase(fetchCategories.fulfilled, (state, { payload }) => { state.categories = payload; });
  },
});

export default productSlice.reducer;
